/**
 * Custom hook to access background settings throughout the application
 */
import { useContext } from "react";

import { BackgroundContext, BackgroundContextType } from "../context/BackgroundProvider";

/**
 * useBackground - Hook for accessing background state and functions
 * @returns {BackgroundContextType} Background state and control methods
 */
export const useBackground = (): BackgroundContextType => {
  const context = useContext<BackgroundContextType | undefined>(BackgroundContext);

  if (!context) {
    throw new Error(
      "useBackground must be used within a BackgroundProvider"
    );
  }

  return context;
};

export default useBackground; 
